var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"twitter-share-link"},[_c('a',{attrs:{"href":_vm.link,"title":"Twitter","data-share":"twitter"}},[_c('i',{staticClass:"fa fa-twitter",on:{"click":function($event){_vm.share(_vm.link)}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9960aff8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/vue/components/share/TwitterShare.vue
// module id = 36
// module chunks = 0